import React from 'react';

const FIELD_TYPE_META = {
  text: { icon: 'T', badge: 'border-blue-200 bg-blue-100 text-blue-700', active: 'border-blue-500 bg-blue-50 text-blue-800 ring-blue-100' },
  multiline: { icon: '¶', badge: 'border-cyan-200 bg-cyan-100 text-cyan-700', active: 'border-cyan-500 bg-cyan-50 text-cyan-800 ring-cyan-100' },
  checkbox: { icon: '✓', badge: 'border-emerald-200 bg-emerald-100 text-emerald-700', active: 'border-emerald-500 bg-emerald-50 text-emerald-800 ring-emerald-100' },
  date: { icon: '15', badge: 'border-amber-200 bg-amber-100 text-amber-800', active: 'border-amber-500 bg-amber-50 text-amber-900 ring-amber-100' },
  signature: { icon: '✍', badge: 'border-fuchsia-200 bg-fuchsia-100 text-fuchsia-700', active: 'border-fuchsia-500 bg-fuchsia-50 text-fuchsia-800 ring-fuchsia-100' },
  photo: { icon: '▧', badge: 'border-rose-200 bg-rose-100 text-rose-700', active: 'border-rose-500 bg-rose-50 text-rose-800 ring-rose-100' },
  number: { icon: '#', badge: 'border-slate-200 bg-slate-100 text-slate-700', active: 'border-slate-500 bg-slate-50 text-slate-800 ring-slate-100' },
  currency: { icon: '£', badge: 'border-lime-200 bg-lime-100 text-lime-800', active: 'border-lime-500 bg-lime-50 text-lime-900 ring-lime-100' },
  time: { icon: '12', badge: 'border-indigo-200 bg-indigo-100 text-indigo-700', active: 'border-indigo-500 bg-indigo-50 text-indigo-800 ring-indigo-100' },
  datetime: { icon: 'DT', badge: 'border-violet-200 bg-violet-100 text-violet-700', active: 'border-violet-500 bg-violet-50 text-violet-800 ring-violet-100' },
  yes_no: { icon: 'Y/N', badge: 'border-teal-200 bg-teal-100 text-teal-700', active: 'border-teal-500 bg-teal-50 text-teal-800 ring-teal-100' },
  dropdown: { icon: '▾', badge: 'border-orange-200 bg-orange-100 text-orange-700', active: 'border-orange-500 bg-orange-50 text-orange-800 ring-orange-100' },
  multi_select: { icon: '☑', badge: 'border-green-200 bg-green-100 text-green-700', active: 'border-green-500 bg-green-50 text-green-800 ring-green-100' },
  initials: { icon: 'AB', badge: 'border-pink-200 bg-pink-100 text-pink-700', active: 'border-pink-500 bg-pink-50 text-pink-800 ring-pink-100' },
  gps_location: { icon: '⌖', badge: 'border-sky-200 bg-sky-100 text-sky-700', active: 'border-sky-500 bg-sky-50 text-sky-800 ring-sky-100' },
  asset_lookup: { icon: '◇', badge: 'border-stone-200 bg-stone-100 text-stone-700', active: 'border-stone-500 bg-stone-50 text-stone-800 ring-stone-100' },
  part_lookup: { icon: '⚙', badge: 'border-yellow-200 bg-yellow-100 text-yellow-800', active: 'border-yellow-500 bg-yellow-50 text-yellow-900 ring-yellow-100' },
};

function metaForType(type) {
  return FIELD_TYPE_META[type] || {
    icon: 'Fld',
    badge: 'border-gray-200 bg-gray-100 text-gray-700',
    active: 'border-blue-600 bg-blue-50 text-blue-800 ring-blue-100',
  };
}

function FieldTypeIconPicker({ label = 'Field Type', value, options, onChange }) {
  const selected = options.find((option) => option.value === value);

  return (
    <div className="w-full max-w-[260px]">
      <div className="mb-2 flex items-center justify-between gap-3">
        <span className="text-xs font-semibold text-gray-600">{label}</span>
        {selected && <span className="truncate text-xs font-medium text-gray-500">{selected.label}</span>}
      </div>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
        {options.map((option) => {
          const isActive = option.value === value;
          const meta = metaForType(option.value);
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={`aspect-square min-h-[58px] rounded-md border px-1.5 py-2 text-center transition ${
                isActive
                  ? `${meta.active} ring-2`
                  : 'border-gray-300 bg-white text-gray-700 hover:border-gray-500 hover:bg-gray-50'
              }`}
              title={option.label}
              aria-label={option.label}
              aria-pressed={isActive}
            >
              <span className="flex h-full flex-col items-center justify-center gap-1">
                <span className={`flex h-7 w-7 items-center justify-center rounded border text-[12px] font-bold leading-none shadow-sm ${meta.badge}`}>
                  {meta.icon}
                </span>
                <span className="max-h-7 overflow-hidden text-[10px] font-semibold leading-tight">{option.label}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default FieldTypeIconPicker;
